<app-shared-dialog
  [title]="((canSubmit$ | async) === true ? (((!isUpdate ? 'common.new' : 'common.update') | translate) + ' ') : '') + ('brands.brand' | translate)"
  [options]="{
    size: 'medium',
    confirmText: (!isUpdate ? 'common.create' : 'common.update') | translate,
    cancelText: 'common.cancel' | translate,
    confirmButtonStyle: 'primary',
    confirmIcon: 'arrow-right',
    confirmIconPosition: 'end',
    customConfirmButton: true
  }"
  (cancel)="closed()">

  <form class="add-brands__form" [formGroup]="form">

    <!-- ── Image drop zone (Knowledge-style) ─────────────────────────── -->
    <div
      *appHasPermission="submitPermission()"
      class="drop-zone"
      [class.has-file]="uploadedImage || displayedImage"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (click)="fileInput.click()">
      <input
        type="file"
        #fileInput
        (change)="onFileChange($event)"
        accept="image/jpeg, image/png, image/gif"
        hidden>
      <ng-container *ngIf="!uploadedImage && !displayedImage">
        <ui-svg-icon svgIcon="upload" size="large" class="drop-zone__icon"></ui-svg-icon>
        <span class="drop-zone__text">{{ 'brands.drag_and_drop_image' | translate }}</span>
        <span class="drop-zone__hint">JPG, PNG, GIF</span>
      </ng-container>
      <ng-container *ngIf="uploadedImage || displayedImage">
        <div class="drop-zone__file">
          <img class="drop-zone__preview"
            [src]="uploadedImage ? 'data:;base64,' + uploadedImage : getImage()"
            alt="">
          <ui-button
            type="transparent"
            icon="close"
            iconSize="small"
            (click)="cancelImage(); $event.stopPropagation()">
          </ui-button>
        </div>
      </ng-container>
    </div>

    <!-- ── Code ────────────────────────────────────────────────────────── -->
    <div class="form-field">
      <label class="form-field__label">{{ 'common.code' | translate }}</label>
      <ui-form-field
        type="text"
        formControlName="code"
        [placeholder]="'common.code' | translate"
        [errorMessages]="{ numericAndAlphaOnly: ('validation.numeric_and_alpha_only' | translate) }">
      </ui-form-field>
    </div>

    <!-- ── Name ────────────────────────────────────────────────────────── -->
    <div class="form-field">
      <label class="form-field__label">{{ 'common.name' | translate }}</label>
      <ui-form-field
        type="text"
        formControlName="name"
        [placeholder]="'common.name' | translate"
        [errorMessages]="{ required: ('validation.required' | translate) }">
      </ui-form-field>
    </div>

    <!-- ── Description ─────────────────────────────────────────────────── -->
    <div class="form-field">
      <label class="form-field__label">{{ 'common.description' | translate }}</label>
      <ui-form-field
        type="text"
        formControlName="description"
        [placeholder]="'common.description' | translate">
      </ui-form-field>
    </div>

    <!-- ── Labels (chips, Knowledge-style) ─────────────────────────────── -->
    <div class="form-field">
      <label class="form-field__label">{{ 'Labels.labels' | translate }}</label>
      <mat-chip-list #chipList>
        <mat-chip
          *ngFor="let tag of tags"
          [removable]="canSubmit"
          (removed)="cancelTag(tag.id)"
          class="brand-chip">
          {{ tag.name }}
          <ui-svg-icon *ngIf="canSubmit" svgIcon="close-cc" size="small" matChipRemove></ui-svg-icon>
        </mat-chip>
        <input
          [placeholder]="'Labels.new_label' | translate"
          #fruitInput
          formControlName="tagControl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [readonly]="!canSubmit">
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let tag of filteredTags$ | async" [value]="tag.name" (click)="onTagSelected(tag)">
          {{ tag.name }}
        </mat-option>
      </mat-autocomplete>
    </div>

  </form>
  <ui-button
    customConfirm
    *appHasPermission="submitPermission()"
    type="primary"
    [label]="(!isUpdate ? 'common.create' : 'common.update') | translate"
    icon="arrow-right"
    iconPosition="end"
    (click)="save()">
  </ui-button>
</app-shared-dialog>
